import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { ErrorHandlerService } from '../../services';
import * as moment from 'moment-timezone';
import { DateTimeConverstionService } from '../../services/index';
var CourseenrolledComponent = /** @class */ (function () {
    function CourseenrolledComponent(dashboardService, errorHandlerService, timeZoneConverstionService, route) {
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.timeZoneConverstionService = timeZoneConverstionService;
        this.route = route;
        this.allenrolled = [];
        this.allenrolleddata = [];
        this.sendMsg = false;
        this.msgData = {};
        this.courseData = {};
        this.reviewPopup = false;
        this.reviewTitle = "";
        this.reviewBy = "";
        this.tutor = 0;
        this.material = 0;
        this.interaction = 0;
        this.value = 0;
        this.comment = "";
        this.review = {};
        this.courseId = "";
        this.msgTitle = "";
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
        this.msgContent = "";
        this.popUp = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.courseRecordings = [];
        this.showCourseRecordings = false;
        this.parentWindowHeight = 0;
        this.parentWindowWidth = 0;
        this.courseRecordingsWindowHeight = 0;
        this.courseRecordingsWindowWidth = 0;
        this.subscriptions = [];
        this.registerMsg = false;
        this.registerMessage = "";
    }
    CourseenrolledComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    CourseenrolledComponent.prototype.reviewClick = function (enroll) {
        this.reviewTitle = enroll.courseFullName;
        this.reviewBy = enroll.creator.firstName + " " + enroll.creator.lastName;
        this.courseId = enroll.courseId;
        this.reviewPopup = true;
    };
    CourseenrolledComponent.prototype.cancelreviewClick = function () {
        this.reviewPopup = false;
    };
    CourseenrolledComponent.prototype.sendreviewClick = function () {
        var _this = this;
        this.review.courseId = this.courseId.toString();
        this.review.reviewCommentsString = this.comment;
        this.review.noOfStars = ((this.tutor + this.material + this.interaction + this.value) / 4).toString();
        var s1 = this.dashboardService.enrolledCourseReview(this.review).subscribe(function (data) {
            _this.dashboardService.enrolledCourse().subscribe(function (data) {
                _this.allenrolleddata = data;
                _this.review = {};
                _this.comment = '';
                _this.reviewPopup = false;
                if (localStorage.getItem('timezone')) {
                    _this.timezone = localStorage.getItem('timezone');
                }
                if (_this.timezone) {
                    _this.timeZonechange(_this.timezone);
                }
                _this.allenrolleddata.forEach(function (element) {
                    element.displayStartDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(_this.timezone, 'date', element.courseStartDTime);
                    element.timeZoneConverted = _this.timezone;
                    element.displayStopDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(_this.timezone, 'date', element.courseEndDTime);
                    element.startTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(_this.timezone, 'time', element.courseStartDTime);
                    element.endTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(_this.timezone, 'time', element.courseEndDTime);
                });
            }, function (error) {
                _this.handleError(error);
            });
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
    };
    CourseenrolledComponent.prototype.sendMessageUser = function () {
        var _this = this;
        this.msgData.isMailRequiredToBeSentToAdmin = true;
        var s2 = this.dashboardService.inboxSendMsg(this.msgData).subscribe(function (data) { _this.sendMsg = false; _this.msgData = {}; }, function (error) {
            _this.sendMsg = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s2);
    };
    CourseenrolledComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.parentWindowHeight = window.innerHeight;
        this.parentWindowWidth = window.innerWidth;
        this.courseRecordingsWindowHeight = Math.floor(this.parentWindowHeight * 0.95);
        this.courseRecordingsWindowWidth = Math.floor(this.parentWindowWidth * 0.90);
        this.showSpinner = true;
        var s3 = this.dashboardService.enrolledCourse().subscribe(function (data) {
            //console.log("............."+JSON.stringify(data));
            _this.allenrolleddata = data;
            if (localStorage.getItem('timezone')) {
                _this.timezone = localStorage.getItem('timezone');
            }
            if (_this.timezone) {
                _this.timeZonechange(_this.timezone);
            }
            _this.allenrolleddata.forEach(function (element) {
                element.displayStartDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(_this.timezone, 'date', element.courseStartDTime);
                element.timeZoneConverted = _this.timezone;
                element.displayStopDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(_this.timezone, 'date', element.courseEndDTime);
                element.startTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(_this.timezone, 'time', element.courseStartDTime);
                element.endTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(_this.timezone, 'time', element.courseEndDTime);
            });
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s3);
        this.registerCourseMessage();
    };
    CourseenrolledComponent.prototype.registerCourseMessage = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            var queryParam = params['success'] || 0;
            if (queryParam != '0') {
                try {
                    var decodedCourseName = atob(queryParam);
                    _this.registerMessage = "You have successfully registered for the session " + decodedCourseName;
                    _this.registerMsg = true;
                    setTimeout(function () {
                        _this.registerMsg = false;
                    }, 3000);
                }
                catch (ex) {
                }
            }
        });
    };
    CourseenrolledComponent.prototype.sendMessage = function (data) {
        this.courseData = data;
        this.msgData.usersInTo = [data.createdByUser];
        this.sendMsg = true;
    };
    CourseenrolledComponent.prototype.displayCourseRecordings = function (courseRecordings) {
        this.courseRecordings = courseRecordings;
        this.showCourseRecordings = true;
    };
    CourseenrolledComponent.prototype.resetShowCourseRecordings = function () {
        this.courseRecordings = [];
        this.showCourseRecordings = false;
    };
    CourseenrolledComponent.prototype.closeRecordingsDialog = function () {
        this.resetShowCourseRecordings();
    };
    CourseenrolledComponent.prototype.openRecordingWindow = function (recordingURL) {
        window.open(recordingURL, "Course Recording", "width=" + this.courseRecordingsWindowWidth + ",height=" + this.courseRecordingsWindowHeight);
    };
    CourseenrolledComponent.prototype.downloadDoc = function (courseId, slidedeck) {
        var _this = this;
        var loader = $("#courseId-" + courseId);
        if (loader.css("display") == "none") {
            loader.css("display", "block");
            loader.parents("fileIconWrap").css("cursor", "default");
            var name_1 = (slidedeck != null && slidedeck != undefined) ? slidedeck : 'doc';
            var doc = this.dashboardService.getDoc(courseId).subscribe(function (data) {
                console.log("doc", data["_body"]);
                var blob = new Blob([data["_body"]], { type: data.headers.get('Content-Type') });
                //saveAs(blob, "tset.jpg");
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none');
                a.href = url;
                a.download = name_1;
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
                loader.css("display", "none");
                loader.parents("fileIconWrap").css("cursor", "pointer");
            }, function (error) {
                loader.css("display", "none");
                loader.parents("fileIconWrap").css("cursor", "pointer");
                _this.handleError(error);
            });
            this.subscriptions.push(doc);
        }
    };
    CourseenrolledComponent.prototype.handleError = function (error) {
        this.showSpinner = false;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    CourseenrolledComponent.prototype.timeZonechange = function (data) {
        var _this = this;
        this.allenrolleddata.forEach(function (element) {
            element.displayStartDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(data, 'date', element.courseStartDTime);
            element.timeZoneConverted = data;
            element.displayStopDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(data, 'date', element.courseEndDTime);
            element.startTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(data, 'time', element.courseStartDTime);
            element.endTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(data, 'time', element.courseEndDTime);
        });
        localStorage.setItem('timezone', data);
    };
    CourseenrolledComponent.prototype.convertTimezone = function (timezone, type, datetime) {
        if (type == 'date') {
            var setdate = moment(datetime, 'YYYY-MM-DD HH:mm Z');
            return setdate.tz(timezone).format('MM/DD/YYYY');
        }
        else {
            var setdate = moment(datetime + '+00:00', 'HH:mmZ');
            return setdate.tz(timezone).format('HH:mm');
        }
    };
    CourseenrolledComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return CourseenrolledComponent;
}());
export { CourseenrolledComponent };
//# sourceMappingURL=courseenrolled.component.js.map